// extracted by mini-css-extract-plugin
export var phone = "_2q-0";